import { AddRecommendationItemAction } from '../../../search/addRecommendationItem/actions/add_recommendation_item_action';
import { Analytics } from './analytics';

export class AddRecommendationItemAnalytics extends Analytics {
    constructor() {
        super();

        AddRecommendationItemAction.ADD_RECOMMENDATION_ITEM_EVENT.on((data) => {
            this.run(() => {
                const item = data.analyticsData.items[0];
                const addRecommendationItemData = {
                    server: 'club/pc',
                    fName: '推奨品に登録',
                    events: ['event270'],
                    items: [this.items(item.getProductName())],
                    soloel: {
                        server: 'club/pc',
                        prop5: '推奨品に登録',
                        events: ['event62'],
                        products: [this.items(item.getProductNameForSoloel())],
                    },
                };
                window.sc_trackLinkAll(addRecommendationItemData, data.target, 'o', 'AddRecomProd');
            });
        });
    }

    private items(productName: string) {
        return {
          category: '',
          productName: productName,
          quantity: '',
          price: '',
          events: [],
          evars: {},
        };
      }
}
